import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useState,
} from 'react';

export interface FilterContextProps {
  selectedDates:
    | {
        start: Date | null;
        end: Date | null;
      }
    | undefined;
  setSelectedDates: Dispatch<
    SetStateAction<
      | {
          start: Date | null;
          end: Date | null;
        }
      | undefined
    >
  >;

  quantities:
    | {
        adults: number;
        children: number;
        infants: number;
      }
    | undefined;
  setQuantities: Dispatch<
    SetStateAction<
      | {
          adults: number;
          children: number;
          infants: number;
        }
      | undefined
    >
  >;
  reviewsLanguageFilter: string | undefined;
  setReviewsLanguageFilter: Dispatch<SetStateAction<string | undefined>>;
  villageFilter:
    | {
        [key: string]: string | undefined;
      }
    | undefined;
  setVillageFilter: Dispatch<
    SetStateAction<
      | {
          [key: string]: string | undefined;
        }
      | undefined
    >
  >;

  handleVillageFilter(params: URLSearchParams): void;
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

interface FilterProviderProps {
  children: ReactNode;
}

const FilterContext = createContext<FilterContextProps>(
  {} as FilterContextProps,
);

export const FilterContextProvider: FC<FilterProviderProps> = ({
  children,
}) => {
  const [selectedDates, setSelectedDates] = useState<{
    start: Date | null;
    end: Date | null;
  }>();
  const [quantities, setQuantities] = useState<{
    adults: number;
    children: number;
    infants: number;
  }>();
  const [reviewsLanguageFilter, setReviewsLanguageFilter] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const [villageFilter, setVillageFilter] = useState<{
    [key: string]: string | undefined;
  }>();

  function handleVillageFilter(params: URLSearchParams) {
    const fetchParams: {
      [key: string]: string | undefined;
    } = {};

    if (params.has('sleeps')) {
      Object.assign(fetchParams, {
        sleeps: params.get('sleeps'),
      });
    }

    if (params.has('infants')) {
      Object.assign(fetchParams, {
        infants: params.get('infants'),
      });
    }

    if (params.has('startDate')) {
      Object.assign(fetchParams, {
        startDate: params.get('startDate'),
      });
    }

    if (params.has('endDate')) {
      Object.assign(fetchParams, {
        endDate: params.get('endDate'),
      });
    }
    setVillageFilter(fetchParams);
  }

  return (
    <FilterContext.Provider
      value={{
        reviewsLanguageFilter,
        setReviewsLanguageFilter,
        villageFilter,
        setVillageFilter,
        handleVillageFilter,
        isLoading,
        setIsLoading,
        quantities,
        setQuantities,
        selectedDates,
        setSelectedDates,
      }}>
      {children}
    </FilterContext.Provider>
  );
};

export default FilterContext;
